var _ = require('underscore');
var $ = require('jquery');
var CustomFieldType = EY.Consultation.Lookups.CustomFieldType;
var Entities = require('Entities');
var consultation = require('Consultation');
/*var Export = require('Export');*/
var Dialog = require('Dialog');
var ExportNode = require('ExportNode');
var Labels = EY.Consultation.Labels;
var Marionette = require('marionette');
var RecordType = EY.Consultation.Lookups.RecordType;
var Resources = EY.Consultation.Resources;
var Geographies = _.indexBy(Resources.Geography, 'id');
var YES = Labels['Boolean_Yes'];
var NO = Labels['Boolean_No'];
var isXlsxDownloadEnabled = EY.Consultation.Lookups.Configuration.EnableXlsxDownload;

var Select = {
    accountingStandard: 1,
    approvalBy: 1,
    approvers: { $filter: { input: { $map: { input: '$approvers', as: 'appr', in: { $cond: { if: { $eq: ['', '$$appr.upn'] }, then: null, else: { $concat: ['$$appr.approverGroupId', '#', { $cond: { if: { $or: [{ $lt: ['$$appr.rank', null] }, { $eq: ['', '$$appr.rank'] }] }, then: '$$appr.givenName', else: { $concat: ['$$appr.givenName', ':', '$$appr.rank'] } } }] } } } } }, as: 'approvers', cond: { '$ne': ['$$approvers', null] } } },
    assignedToGivenName: 1,
    attachments: { $reduce: { input: '$attachments.filename', initialValue: '', in: { $concat: ['$$value', { $cond: { if: { $eq: ['$$value', ''] }, then: ' ', else: ', ' } }, '$$this'] } } },
    auditClient: 1,
    clientId: 1,
    clientName: 1,
    closeMonitoring: { $cond: { if: '$configuration.DisplayCloseMonitoring', then: '$closeMonitoring', else: '' } },
    completedOn: 1,
    countryId: 1,
    createdOn: 1,
    creatorGivenName: 1,
    descriptionAA: { $cond: { if: { $eq: ['$recordTypeId', RecordType.AdvanceApproval] }, then: '$description', else: '' } },
    descriptionRN: { $cond: { if: { $eq: ['$recordTypeId', RecordType.RequiredNotification] }, then: '$description', else: '' } },
    engagementId: 1,
    engagementName: 1,
    fiscalYearEnd: 1,
    fields: 1,
    geographyId: 1,
    geographyTypePath: 1,
    id: 1,
    industryId: 1,
    listedEntity: { $cond: { if: '$configuration.DisplayListedEntity', then: '$listedEntity', else: '' } },
    nonListedPie: { $cond: { if: '$configuration.DisplayNonListedPIE', then: '$nonListedPie', else: '' } },
    partner: 1,
    recordTypeId: 1,
    restricted: 1,
    secRegistrant: { $cond: { if: '$configuration.DisplaySEC', then: '$secRegistrant', else: '' } },
    statusResourceKey: 1,
    subject: 1,
    subjectDescription: 1,
    subtype: 1,
    type: 1
};

var columns = function() {
    return [
        { name: 'shortId', label: Labels.RecordID, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'recordTypeId', label: Labels.RecordType, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'statusTypeId', label: Labels.Status, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'createdOn', label: Labels.CreationDate, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'completedOn', label: Labels.DateCompleted, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'approvalBy', label: Labels.ApproveBy, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'engagementName', label: Labels.EngagementName, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'engagementId', label: Labels.EngagementNumber, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'clientName', label: Labels.ClientName, editable: false, cell: 'string', columnWidth: 'XL' },
        { name: 'clientId', label: Labels.ClientCode, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'area', label: Labels.Area, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'region', label: Labels.Region, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'country', label: Labels.Country, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'usregion', label: Labels.USRegion, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'office', label: Labels.Office, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'type', label: Labels.Topic, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'subtype', label: Labels.Subtopic1, editable: false, cell: 'string', columnWidth: 'XL' },
        { name: 'subject', label: Labels.Subject, editable: false, cell: 'string', columnWidth: 'XL' },
        { name: 'assignedToGivenName', label: Labels.AssignedTo, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'creatorGivenName', label: Labels.CreatorName, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'teamMember', label: Labels.ApproverGroup_TeamMember, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'partner', label: Labels.PartnerInCharge, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'eqr', label: Labels.ApproverGroup_EngagementQualityReviewer, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'usregionPP', label: Labels.ApproverGroup_USRegionProfessionalPractice, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'cpp', label: Labels.ApproverGroup_CountryProfessionalPractice, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'rpp', label: Labels.ApproverGroup_RegionalProfessionalPractice, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'app', label: Labels.ApproverGroup_AreaProfessionalPractice, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'gpp', label: Labels.ApproverGroup_GlobalProfessionalPractice, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'advanceApprovers', label: Labels.AdvanceApprover, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'notificationTo', label: Labels.ApproverGroup_RequiredNotification, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'fiscalYearEnd', label: Labels.FiscalYearEnd, editable: false, cell: 'string', columnWidth: 'S' },
        { name: 'industryId', label: Labels.Industry, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'auditClient', label: Labels.AuditClient, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'secRegistrant', label: Labels.SECRegistrant, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'listedEntity', label: Labels.ListedEntity, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'nonListedPie', label: Labels.NonListedPIE, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'closeMonitoring', label: Labels.CloseMonitoring, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'restricted', label: Labels.RestrictedRecord, editable: false, cell: 'string', columnWidth: 'M' },
        { name: 'subjectDescription', label: Labels.SubjectDescription, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'attachments', label: Labels.Attachments, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'descriptionAA', label: Labels.RecordType_AdvanceApproval_Description, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'descriptionRN', label: Labels.RecordType_RequiredNotification_Description, editable: false, cell: 'string', columnWidth: 'L' },
        { name: 'accountingStandard', label: Labels.PrimaryAccountingStandards, editable: false, cell: 'string', columnWidth: 'XL' },
        { name: 'fields', label: Labels.CustomField, editable: false, cell: 'string', columnWidth: 'XL' }
    ];
};
var fields = function () {
    return [
        { value: 'shortId', label: Labels.RecordID },
        { value: 'recordTypeId', label: Labels.RecordType },
        { value: 'statusTypeId', label: Labels.Status },
        { value: 'createdOn', label: Labels.CreationDate },
        { value: 'completedOn', label: Labels.DateCompleted },
        { value: 'approvalBy', label: Labels.ApproveBy },
        { value: 'engagementName', label: Labels.EngagementName },
        { value: 'engagementId', label: Labels.EngagementNumber },
        { value: 'clientName', label: Labels.ClientName },
        { value: 'clientId', label: Labels.ClientCode },
        { value: 'area', label: Labels.Area },
        { value: 'region', label: Labels.Region },
        { value: 'country', label: Labels.Country },
        { value: 'usregion', label: Labels.USRegion },
        { value: 'office', label: Labels.Office },
        { value: 'type', label: Labels.Topic },
        { value: 'subtype', label: Labels.Subtopic1 },
        { value: 'subject', label: Labels.Subject },
        { value: 'assignedToGivenName', label: Labels.AssignedTo },
        { value: 'creatorGivenName', label: Labels.CreatorName },
        { value: 'teamMember', label: Labels.ApproverGroup_TeamMember },
        { value: 'partner', label: Labels.PartnerInCharge },
        { value: 'eqr', label: Labels.ApproverGroup_EngagementQualityReviewer },
        { value: 'usregionPP', label: Labels.ApproverGroup_USRegionProfessionalPractice },
        { value: 'cpp', label: Labels.ApproverGroup_CountryProfessionalPractice },
        { value: 'rpp', label: Labels.ApproverGroup_RegionalProfessionalPractice },
        { value: 'app', label: Labels.ApproverGroup_AreaProfessionalPractice },
        { value: 'gpp', label: Labels.ApproverGroup_GlobalProfessionalPractice },
        { value: 'advanceApprovers', label: Labels.AdvanceApprover },
        { value: 'notificationTo', label: Labels.ApproverGroup_RequiredNotification },
        { value: 'fiscalYearEnd', label: Labels.FiscalYearEnd },
        { value: 'industryId', label: Labels.Industry },
        { value: 'auditClient', label: Labels.AuditClient },
        { value: 'secRegistrant', label: Labels.SECRegistrant },
        { value: 'listedEntity', label: Labels.ListedEntity },
        { value: 'nonListedPie', label: Labels.NonListedPIE },
        { value: 'closeMonitoring', label: Labels.CloseMonitoring },
        { value: 'restricted', label: Labels.RestrictedRecord },
        { value: 'subjectDescription', label: Labels.SubjectDescription },
        { value: 'attachments', label: Labels.Attachments },
        { value: 'descriptionAA', label: Labels.RecordType_AdvanceApproval_Description },
        { value: 'descriptionRN', label: Labels.RecordType_RequiredNotification_Description },
        { value: 'accountingStandard', label: Labels.PrimaryAccountingStandards },
        { value: 'fields', label: Labels.CustomField }];
};
var filter = function(approvers, regex) {
    var filtered = (approvers.match(new RegExp(regex.source + '[^,]*', 'g')) || []).join(',');

    return (/:/.test(filtered) ? filtered.replace(/:/g, ' (').replace(/,/g, '),') + ')' : filtered).replace(regex, '');
};// Parse input [approverGroup#approverName,approverGroup#approverName:role] to required format [approverName, approverName(role)]

var format = function (records) {
    
    records.on('synced', function() {
        records.each(function(record) {
            var approvers = (record.get('approvers') || []).join(',');

            _.chain(approvers.match(/\w*_\w*[-\w]*/g)).each(function(role) {
                approvers = approvers.replace(role, Labels[role]);
            });

            var fieldValues = _.reduce(_.map(record.get('fields'), function (field) {
                var value = (field.answer ? (field.customFieldTypeId == CustomFieldType.Date ? new Date(field.answer).format() : field.answer) : "");
                if (field.customFieldTypeId == CustomFieldType.Dropdown) {
                    value = _.find(field.answer, {
                    selected: true
                    });
                    value = value ? value.text : "";
                }
                return field.name + ': ' + value;
            }), function (retValue, field) {
                    if (field) {
                        return retValue + ', ' + field;
                }
                return retValue;
            });

                record.set({
                shortId: isXlsxDownloadEnabled ? record.get('shortId') : "=\"" + record.get('shortId')+"\"",
                recordTypeId: Labels[record.get('recordTypeId')],
                statusTypeId: Labels[record.get('statusResourceKey')],
                createdOn: record.get('createdOn') ? new Date(record.get('createdOn')).format() : '',
                fiscalYearEnd: record.get('fiscalYearEnd') ? new Date(record.get('fiscalYearEnd')).format() : '',
                industryId: record.get('industryId') === '' || record.get('industryId') === -1 ? '' : Labels["Industry_" + record.get('industryId')],
                auditClient: record.get('auditClient') ? YES : NO,
                secRegistrant: record.get('secRegistrant') === '' ? '' : record.get('secRegistrant') ? YES : NO,
                listedEntity: record.get('listedEntity') === '' ? '' : record.get('listedEntity') ? YES : NO,
                nonListedPie: record.get('nonListedPie') === '' ? '' : record.get('nonListedPie') ? YES : NO,
                closeMonitoring: record.get('closeMonitoring') === '' ? '' : record.get('closeMonitoring') ? YES : NO,
                area: Geographies[record.get('countryId').replace(/[^\/]*\/[^\/]*\/$/, '')].text,
                region: Geographies[record.get('countryId').replace(/[^\/]*\/$/, '')].text,
                country: Geographies[record.get('countryId')].text,
                usregion: /SubCountry/.test(record.get('geographyTypePath')) ? Geographies[record.get('geographyId')].text : '',
                office: /Office/.test(record.get('geographyTypePath')) ? Geographies[record.get('geographyId')].text : '',
                approvalBy: record.get('approvalBy') === '' ? '' : record.get('approvalBy') ? new Date(record.get('approvalBy')).format() : '',
                teamMember: filter(approvers, /TeamMember#/g),
                eqr: record.get('recordTypeId') === RecordType.AdvanceApproval || 
                    record.get('recordTypeId') === RecordType.Consultation || 
                    record.get('recordTypeId') === RecordType.RequiredNotification ? filter(approvers, /EngagementQualityReviewer#/g) : '',
                cpp: filter(approvers, /,CountryProfessionalPractice#/g),
                rpp: filter(approvers, /RegionalProfessionalPractice#/g),
                usregionPP: filter(approvers, /SubCountryProfessionalPractice#/g),
                app: record.get('recordTypeId') === RecordType.Consultation ? filter(approvers, /AreaProfessionalPractice#/g) : '',
                gpp: record.get('recordTypeId') === RecordType.Consultation ? filter(approvers, /GlobalProfessionalPractice#/g) : '',
                advanceApprovers: record.get('recordTypeId') === RecordType.AdvanceApproval ? filter(approvers, /AdvanceApprover#/g) : '',
                notificationTo: record.get('recordTypeId') === RecordType.RequiredNotification ? filter(approvers, /RequiredNotification#/g) : '',
                completedOn: record.get('completedOn') ? new Date(record.get('completedOn')).format() : '',
                restricted: record.get('restricted') ? YES : NO,
                accountingStandard: record.get('accountingStandard') ? Labels[record.get('accountingStandard')] : "",
                fields: fieldValues
                
            });
                   
        });
    });
    return records;
};

//module.exports.run = function(options) {
//    //var query = options.query;
//    //var aggregate = query.get('aggregate');
//    //var pipeline = aggregate && aggregate.length ? aggregate.concat({ $project: Select }) : [{ $match: query.get('filter') }, { $project: Select }];
//    //var queries = new Entities.Queries([{ id: query.id, text: query.get('text'), filter: {}, select: {}, type: query.get('type'), aggregate: pipeline, selected: true }]);

//    var queryAllRecord = options.queries.get('AllRecords');
//    var pipeline = [{ $match: queryAllRecord.get('filter') }];

//   var query = "filter={}&select={}&aggregate="+JSON.stringify(pipeline);

//   // Export.run({ collection: format(new Entities.Records()), columns: columns(), fields: fields(), name: Labels.ExportRecordsFileName, queries: queries });
//    ExportNode.send({ path: "Record", query: query, columns: columns(), fields: fields(), fileName: Labels.ExportRecordsFileName });

//};
var Confirmation = Marionette.View.extend({
    template: '#exportConfirmation'
});

module.exports.run = function (options) {
    var query = options.query;
    var aggregate = query.get('aggregate');
    var pipeline = aggregate && aggregate.length ? aggregate.concat({ $project: Select }) : [{ $match: query.get('filter') }, { $project: Select }];
    var queries = new Entities.Queries([{ id: query.id, text: query.get('text'), filter: {}, select: {}, type: query.get('type'), aggregate: pipeline, selected: true }]);
    var collection = format(new Entities.Records());
    var selectedQuery = queries.findWhere({ selected: true }) || queries.get('');
    var handleFileDownload = isXlsxDownloadEnabled ? $.Deferred().resolve() : Dialog.show({
        saveLabel: Labels.OK,
        headerLabel: Labels.DialogTitleInformational,
        view: new Confirmation({
            model: new Backbone.Model({ message: Labels.MSG031})
        })
    });

    handleFileDownload.done(function () {
        $('html,body').addClass('wait-cursor');
        var options = _.pick(selectedQuery.attributes, ['aggregate', 'filter', 'select']);
        options.error = function() { 
            $('html,body').removeClass('wait-cursor');
            consultation.showToast({
                result: "danger",
                text: Labels.ExportWarningMessage
            });
        };

        collection.fetch(options).done(function () {
            // Export.run({ collection: format(new Entities.Records()), columns: columns(), fields: fields(), name: Labels.ExportRecordsFileName, queries: queries });
            ExportNode.send({ collection: collection, query: query, columns: columns(), fields: fields(), fileName: Labels.ExportRecordsFileName, queries: queries });
            $('html,body').removeClass('wait-cursor');
        }).fail(function () {
            $('html,body').removeClass('wait-cursor');
        });
    });
};


// WEBPACK FOOTER //
// ./js/Modules/Home/HomeExport.js